import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  forwardRef,
} from '@angular/core';
import {
  DefaultValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

const TRIM_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TrimDirective),
  multi: true,
};
@Directive({
  standalone: false,
  selector: `
        [appTrim]
      `,
  providers: [TRIM_VALUE_ACCESSOR],
})
export class TrimDirective extends DefaultValueAccessor {
  constructor(renderer: Renderer2, elementRef: ElementRef) {
    super(renderer, elementRef, false);
  }
  @HostListener('input', ['$event'])
  ngOnChange = ($event: Event): void => {
    const target = $event.target as HTMLInputElement;
    this.onChange(target.value.trim());
  };

  @HostListener('blur', ['$event'])
  applyTrim($event: Event): void {
    const target = $event.target as HTMLInputElement;
    this.writeValue(target.value.trim());
  }

  writeValue(value: any): void {
    if (typeof value === 'string') {
      value = value.trim();
    }

    super.writeValue(value);
  }
}
